export default [
  { name_short: 'CN', name_cn: '中国大陆', name_en: 'Mainland China', code: '86' },
  { name_short: 'HK', name_cn: '香港', name_en: 'Hong Kong', code: '852' },
  { name_short: 'MO', name_cn: '澳门', name_en: 'Macau', code: '853' },
  { name_short: 'TW', name_cn: '台湾', name_en: 'Taiwan', code: '886' },
  { name_short: 'US', name_cn: '美国', name_en: 'United States', code: '1' },
  { name_short: 'AD', name_cn: '安道尔', name_en: 'Andorra', code: '376' },
  { name_short: 'AE', name_cn: '阿拉伯联合酋长国', name_en: 'United Arab Emirates', code: '971' },
  { name_short: 'AG', name_cn: '安提瓜和巴布达', name_en: 'Antigua and Barbuda', code: '1268' },
  { name_short: 'AI', name_cn: '安圭拉', name_en: 'Anguilla', code: '1264' },
  { name_short: 'AO', name_cn: '安哥拉', name_en: 'Angola', code: '244' },
  { name_short: 'AR', name_cn: '阿根廷', name_en: 'Argentina', code: '54' },
  { name_short: 'AT', name_cn: '奥地利', name_en: 'Austria', code: '43' },
  { name_short: 'AU', name_cn: '澳大利亚', name_en: 'Australia', code: '61' },
  { name_short: 'AW', name_cn: '阿鲁巴', name_en: 'Aruba', code: '297' },
  { name_short: 'BB', name_cn: '巴巴多斯', name_en: 'Barbados', code: '1246' },
  { name_short: 'BD', name_cn: '孟加拉国', name_en: 'Bangladesh', code: '880' },
  { name_short: 'BF', name_cn: '布基纳法索', name_en: 'Burkina Faso', code: '226' },
  { name_short: 'BH', name_cn: '巴林', name_en: 'Bahrain', code: '973' },
  { name_short: 'BJ', name_cn: '贝宁', name_en: 'Benin', code: '229' },
  { name_short: 'BM', name_cn: '百慕大群岛', name_en: 'Bermuda', code: '1441' },
  { name_short: 'BN', name_cn: '文莱', name_en: 'Brunei', code: '673' },
  { name_short: 'BO', name_cn: '玻利维亚', name_en: 'Bolivia', code: '591' },
  { name_short: 'BQ', name_cn: '博内尔岛,圣尤斯特歇斯和萨巴', name_en: 'Bonaire,Sint Eustatius and Saba', code: '599' },
  { name_short: 'BR', name_cn: '巴西', name_en: 'Brazil', code: '55' },
  { name_short: 'BS', name_cn: '巴哈马', name_en: 'Bahamas', code: '1242' },
  { name_short: 'BT', name_cn: '不丹', name_en: 'Bhutan', code: '975' },
  { name_short: 'BW', name_cn: '博茨瓦纳', name_en: 'Botswana', code: '267' },
  { name_short: 'BY', name_cn: '白俄罗斯', name_en: 'Belarus', code: '375' },
  { name_short: 'BZ', name_cn: '伯利兹', name_en: 'Belize', code: '501' },
  { name_short: 'CA', name_cn: '加拿大', name_en: 'Canada', code: '1' },
  { name_short: 'CD', name_cn: '刚果民主共和国', name_en: 'Democratic Republic of the Congo', code: '243' },
  { name_short: 'CF', name_cn: '中非共和国', name_en: 'Central African Republic', code: '236' },
  { name_short: 'CG', name_cn: '刚果共和国', name_en: 'Republic Of The Congo', code: '242' },
  { name_short: 'CH', name_cn: '瑞士', name_en: 'Switzerland', code: '41' },
  { name_short: 'CK', name_cn: '库克群岛', name_en: 'Cook Islands', code: '682' },
  { name_short: 'CL', name_cn: '智利', name_en: 'Chile', code: '56' },
  { name_short: 'CM', name_cn: '喀麦隆', name_en: 'Cameroon', code: '237' },
  { name_short: 'CO', name_cn: '哥伦比亚', name_en: 'Colombia', code: '57' },
  { name_short: 'CR', name_cn: '哥斯达黎加', name_en: 'Costa Rica', code: '506' },
  { name_short: 'CU', name_cn: '古巴', name_en: 'Cuba', code: '53' },
  { name_short: 'CV', name_cn: '开普', name_en: 'Cape Verde', code: '238' },
  { name_short: 'CW', name_cn: '库拉索', name_en: 'Curacao', code: '599' },
  { name_short: 'CZ', name_cn: '捷克', name_en: 'Czech Republic', code: '420' },
  { name_short: 'DE', name_cn: '德国', name_en: 'Germany', code: '49' },
  { name_short: 'DK', name_cn: '丹麦', name_en: 'Denmark', code: '45' },
  { name_short: 'DM', name_cn: '多米尼加', name_en: 'Dominica', code: '1767' },
  { name_short: 'DO', name_cn: '多明尼加共和国', name_en: 'Dominican Republic', code: '1809' },
  { name_short: 'DZ', name_cn: '阿尔及利亚', name_en: 'Algeria', code: '213' },
  { name_short: 'EC', name_cn: '厄瓜多尔', name_en: 'Ecuador', code: '593' },
  { name_short: 'EG', name_cn: '埃及', name_en: 'Egypt', code: '20' },
  { name_short: 'ES', name_cn: '西班牙', name_en: 'Spain', code: '34' },
  { name_short: 'ET', name_cn: '埃塞俄比亚', name_en: 'Ethiopia', code: '251' },
  { name_short: 'FI', name_cn: '芬兰', name_en: 'Finland', code: '358' },
  { name_short: 'FJ', name_cn: '斐济', name_en: 'Fiji', code: '679' },
  { name_short: 'FO', name_cn: '法罗群岛', name_en: 'Faroe Islands', code: '298' },
  { name_short: 'FR', name_cn: '法国', name_en: 'France', code: '33' },
  { name_short: 'GA', name_cn: '加蓬', name_en: 'Gabon', code: '241' },
  { name_short: 'GB', name_cn: '英国', name_en: 'United Kingdom', code: '44' },
  { name_short: 'GD', name_cn: '格林纳达', name_en: 'Grenada', code: '1473' },
  { name_short: 'GE', name_cn: '格鲁吉亚', name_en: 'Georgia', code: '995' },
  { name_short: 'GH', name_cn: '加纳', name_en: 'Ghana', code: '233' },
  { name_short: 'GI', name_cn: '直布罗陀', name_en: 'Gibraltar', code: '350' },
  { name_short: 'GL', name_cn: '格陵兰岛', name_en: 'Greenland', code: '299' },
  { name_short: 'GM', name_cn: '冈比亚', name_en: 'Gambia', code: '220' },
  { name_short: 'GQ', name_cn: '赤道几内亚', name_en: 'Equatorial Guinea', code: '240' },
  { name_short: 'GR', name_cn: '希腊', name_en: 'Greece', code: '30' },
  { name_short: 'GT', name_cn: '瓜地马拉', name_en: 'Guatemala', code: '502' },
  { name_short: 'GU', name_cn: '关岛', name_en: 'Guam', code: '1671' },
  { name_short: 'GW', name_cn: '几内亚比绍共和国', name_en: 'Guinea-Bissau', code: '245' },
  { name_short: 'GY', name_cn: '圭亚那', name_en: 'Guyana', code: '592' },
  { name_short: 'HN', name_cn: '洪都拉斯', name_en: 'Honduras', code: '504' },
  { name_short: 'HR', name_cn: '克罗地亚', name_en: 'Croatia', code: '385' },
  { name_short: 'HT', name_cn: '海地', name_en: 'Haiti', code: '509' },
  { name_short: 'HU', name_cn: '匈牙利', name_en: 'Hungary', code: '36' },
  { name_short: 'ID', name_cn: '印度尼西亚', name_en: 'Indonesia', code: '62' },
  { name_short: 'IE', name_cn: '爱尔兰', name_en: 'Ireland', code: '353' },
  { name_short: 'IL', name_cn: '以色列', name_en: 'Israel', code: '972' },
  { name_short: 'IN', name_cn: '印度', name_en: 'India', code: '91' },
  { name_short: 'IQ', name_cn: '伊拉克', name_en: 'Iraq', code: '964' },
  { name_short: 'IR', name_cn: '伊朗', name_en: 'Iran', code: '98' },
  { name_short: 'IS', name_cn: '冰岛', name_en: 'Iceland', code: '354' },
  { name_short: 'IT', name_cn: '意大利', name_en: 'Italy', code: '39' },
  { name_short: 'JM', name_cn: '牙买加', name_en: 'Jamaica', code: '1876' },
  { name_short: 'JO', name_cn: '约旦', name_en: 'Jordan', code: '962' },
  { name_short: 'JP', name_cn: '日本', name_en: 'Japan', code: '81' },
  { name_short: 'KE', name_cn: '肯尼亚', name_en: 'Kenya', code: '254' },
  { name_short: 'KG', name_cn: '吉尔吉斯斯坦', name_en: 'Kyrgyzstan', code: '996' },
  { name_short: 'KH', name_cn: '柬埔寨', name_en: 'Cambodia', code: '855' },
  { name_short: 'KI', name_cn: '基里巴斯', name_en: 'Kiribati', code: '686' },
  { name_short: 'KM', name_cn: '科摩罗', name_en: 'Comoros', code: '269' },
  { name_short: 'KR', name_cn: '韩国', name_en: 'South Korea', code: '82' },
  { name_short: 'KW', name_cn: '科威特', name_en: 'Kuwait', code: '965' },
  { name_short: 'KY', name_cn: '开曼群岛', name_en: 'Cayman Islands', code: '1345' },
  { name_short: 'KZ', name_cn: '哈萨克斯坦', name_en: 'Kazakhstan', code: '7' },
  { name_short: 'LA', name_cn: '老挝', name_en: 'Laos', code: '856' },
  { name_short: 'LB', name_cn: '黎巴嫩', name_en: 'Lebanon', code: '961' },
  { name_short: 'LC', name_cn: '圣露西亚', name_en: 'Saint Lucia', code: '1758' },
  { name_short: 'LI', name_cn: '列支敦士登', name_en: 'Liechtenstein', code: '423' },
  { name_short: 'LK', name_cn: '斯里兰卡', name_en: 'Sri Lanka', code: '94' },
  { name_short: 'LR', name_cn: '利比里亚', name_en: 'Liberia', code: '231' },
  { name_short: 'LT', name_cn: '立陶宛', name_en: 'Lithuania', code: '370' },
  { name_short: 'LU', name_cn: '卢森堡', name_en: 'Luxembourg', code: '352' },
  { name_short: 'LV', name_cn: '拉脱维亚', name_en: 'Latvia', code: '371' },
  { name_short: 'LY', name_cn: '利比亚', name_en: 'Libya', code: '218' },
  { name_short: 'MD', name_cn: '摩尔多瓦', name_en: 'Moldova', code: '373' },
  { name_short: 'ME', name_cn: '黑山', name_en: 'Montenegro', code: '382' },
  { name_short: 'MG', name_cn: '马达加斯加', name_en: 'Madagascar', code: '261' },
  { name_short: 'MK', name_cn: '马其顿', name_en: 'Macedonia', code: '389' },
  { name_short: 'MN', name_cn: '蒙古', name_en: 'Mongolia', code: '976' },
  { name_short: 'MS', name_cn: '蒙特塞拉特岛', name_en: 'Montserrat', code: '1664' },
  { name_short: 'MT', name_cn: '马耳他', name_en: 'Malta', code: '356' },
  { name_short: 'MU', name_cn: '毛里求斯', name_en: 'Mauritius', code: '230' },
  { name_short: 'MV', name_cn: '马尔代夫', name_en: 'Maldives', code: '960' },
  { name_short: 'MW', name_cn: '马拉维', name_en: 'Malawi', code: '265' },
  { name_short: 'MX', name_cn: '墨西哥', name_en: 'Mexico', code: '52' },
  { name_short: 'MY', name_cn: '马来西亚', name_en: 'Malaysia', code: '60' },
  { name_short: 'MZ', name_cn: '莫桑比克', name_en: 'Mozambique', code: '258' },
  { name_short: 'NA', name_cn: '纳米比亚', name_en: 'Namibia', code: '264' },
  { name_short: 'NE', name_cn: '尼日尔', name_en: 'Niger', code: '227' },
  { name_short: 'NG', name_cn: '尼日利亚', name_en: 'Nigeria', code: '234' },
  { name_short: 'NI', name_cn: '尼加拉瓜', name_en: 'Nicaragua', code: '505' },
  { name_short: 'NL', name_cn: '荷兰', name_en: 'Netherlands', code: '31' },
  { name_short: 'NO', name_cn: '挪威', name_en: 'Norway', code: '47' },
  { name_short: 'NP', name_cn: '尼泊尔', name_en: 'Nepal', code: '977' },
  { name_short: 'NZ', name_cn: '新西兰', name_en: 'New Zealand', code: '64' },
  { name_short: 'OM', name_cn: '阿曼', name_en: 'Oman', code: '968' },
  { name_short: 'PA', name_cn: '巴拿马', name_en: 'Panama', code: '507' },
  { name_short: 'PE', name_cn: '秘鲁', name_en: 'Peru', code: '51' },
  { name_short: 'PG', name_cn: '巴布亚新几内亚', name_en: 'Papua New Guinea', code: '675' },
  { name_short: 'PH', name_cn: '菲律宾', name_en: 'Philippines', code: '63' },
  { name_short: 'PK', name_cn: '巴基斯坦', name_en: 'Pakistan', code: '92' },
  { name_short: 'PL', name_cn: '波兰', name_en: 'Poland', code: '48' },
  { name_short: 'PM', name_cn: '圣彼埃尔和密克隆岛', name_en: 'Saint Pierre and Miquelon', code: '508' },
  { name_short: 'PR', name_cn: '波多黎各', name_en: 'Puerto Rico', code: '1787' },
  { name_short: 'PS', name_cn: '巴勒斯坦领土', name_en: 'Palestinian Territory', code: '970' },
  { name_short: 'PT', name_cn: '葡萄牙', name_en: 'Portugal', code: '351' },
  { name_short: 'PW', name_cn: '帕劳', name_en: 'Palau', code: '680' },
  { name_short: 'PY', name_cn: '巴拉圭', name_en: 'Paraguay', code: '595' },
  { name_short: 'QA', name_cn: '卡塔尔', name_en: 'Qatar', code: '974' },
  { name_short: 'RO', name_cn: '罗马尼亚', name_en: 'Romania', code: '40' },
  { name_short: 'RS', name_cn: '塞尔维亚', name_en: 'Serbia', code: '381' },
  { name_short: 'RU', name_cn: '俄罗斯', name_en: 'Russia', code: '7' },
  { name_short: 'RW', name_cn: '卢旺达', name_en: 'Rwanda', code: '250' },
  { name_short: 'SA', name_cn: '沙特阿拉伯', name_en: 'Saudi Arabia', code: '966' },
  { name_short: 'SC', name_cn: '塞舌尔', name_en: 'Seychelles', code: '248' },
  { name_short: 'SD', name_cn: '苏丹', name_en: 'Sudan', code: '249' },
  { name_short: 'SE', name_cn: '瑞典', name_en: 'Sweden', code: '46' },
  { name_short: 'SG', name_cn: '新加坡', name_en: 'Singapore', code: '65' },
  { name_short: 'SI', name_cn: '斯洛文尼亚', name_en: 'Slovenia', code: '386' },
  { name_short: 'SK', name_cn: '斯洛伐克', name_en: 'Slovakia', code: '421' },
  { name_short: 'SL', name_cn: '塞拉利昂', name_en: 'Sierra Leone', code: '232' },
  { name_short: 'SM', name_cn: '圣马力诺', name_en: 'San Marino', code: '378' },
  { name_short: 'SN', name_cn: '塞内加尔', name_en: 'Senegal', code: '221' },
  { name_short: 'SO', name_cn: '索马里', name_en: 'Somalia', code: '252' },
  { name_short: 'SR', name_cn: '苏里南', name_en: 'Suriname', code: '597' },
  { name_short: 'SS', name_cn: '南苏丹', name_en: 'South Sudan', code: '211' },
  { name_short: 'SV', name_cn: '萨尔瓦多', name_en: 'El Salvador', code: '503' },
  { name_short: 'SX', name_cn: '圣马丁岛(荷兰部分)', name_en: 'Sint Maarten (Dutch Part)', code: '1721' },
  { name_short: 'SY', name_cn: '叙利亚', name_en: 'Syria', code: '963' },
  { name_short: 'SZ', name_cn: '斯威士兰', name_en: 'Swaziland', code: '268' },
  { name_short: 'TC', name_cn: '特克斯和凯科斯群岛', name_en: 'Turks and Caicos Islands', code: '1649' },
  { name_short: 'TD', name_cn: '乍得', name_en: 'Chad', code: '235' },
  { name_short: 'TG', name_cn: '多哥', name_en: 'Togo', code: '228' },
  { name_short: 'TH', name_cn: '泰国', name_en: 'Thailand', code: '66' },
  { name_short: 'TJ', name_cn: '塔吉克斯坦', name_en: 'Tajikistan', code: '992' },
  { name_short: 'TN', name_cn: '突尼斯', name_en: 'Tunisia', code: '216' },
  { name_short: 'TO', name_cn: '汤加', name_en: 'Tonga', code: '676' },
  { name_short: 'TR', name_cn: '土耳其', name_en: 'Turkey', code: '90' },
  { name_short: 'TT', name_cn: '特立尼达和多巴哥', name_en: 'Trinidad and Tobago', code: '1868' },
  { name_short: 'TZ', name_cn: '坦桑尼亚', name_en: 'Tanzania', code: '255' },
  { name_short: 'UG', name_cn: '乌干达', name_en: 'Uganda', code: '256' },
  { name_short: 'UY', name_cn: '乌拉圭', name_en: 'Uruguay', code: '598' },
  { name_short: 'UZ', name_cn: '乌兹别克斯坦', name_en: 'Uzbekistan', code: '998' },
  { name_short: 'VC', name_cn: '圣文森特和格林纳丁斯', name_en: 'Saint Vincent and The Grenadines', code: '1784' },
  { name_short: 'VE', name_cn: '委内瑞拉', name_en: 'Venezuela', code: '58' },
  { name_short: 'VG', name_cn: '英属处女群岛', name_en: 'Virgin Islands British', code: '1340' },
  { name_short: 'VI', name_cn: '美属维尔京群岛', name_en: 'Virgin Islands US', code: '1284' },
  { name_short: 'VN', name_cn: '越南', name_en: 'Vietnam', code: '84' },
  { name_short: 'VU', name_cn: '瓦努阿图', name_en: 'Vanuatu', code: '678' },
  { name_short: 'WS', name_cn: '萨摩亚', name_en: 'Samoa', code: '685' },
  { name_short: 'YE', name_cn: '也门', name_en: 'Yemen', code: '967' },
  { name_short: 'ZA', name_cn: '南非', name_en: 'South Africa', code: '27' },
  { name_short: 'ZM', name_cn: '赞比亚', name_en: 'Zambia', code: '260' }
];

